import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function WholesaleInfoPopup({
  isOpen,
  onClose
}) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  if (!isOpen) return null;
  const handleOptionSelect = (option: string) => {
    setSelectedOption(option);
  };
  const handleClose = () => {
    setSelectedOption(null);
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4" data-id="element-302">
      <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-303">
        <div className="bg-blue-600 text-white p-4 flex justify-between items-center" data-id="element-304">
          <h2 className="text-xl font-bold" data-id="element-305">Wholesale Account Information</h2>
          <button onClick={handleClose} className="hover:bg-blue-700 rounded-full p-1 transition-colors" data-id="element-306">
            <XIcon className="w-6 h-6" data-id="element-307" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1" data-id="element-308">
          {!selectedOption ? <>
              <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-309">
                Do you have a Wholesale Account?
              </h3>
              <div className="space-y-3" data-id="element-310">
                <button onClick={() => handleOptionSelect('yes')} className="w-full bg-green-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-green-700 transition-colors" data-id="element-311">
                  Yes, I have a wholesale account
                </button>
                <button onClick={() => handleOptionSelect('no')} className="w-full bg-red-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-red-700 transition-colors" data-id="element-312">
                  No, I don't have a wholesale account
                </button>
                <button onClick={() => handleOptionSelect('unsure')} className="w-full bg-gray-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-gray-700 transition-colors" data-id="element-313">
                  Not Sure
                </button>
              </div>
            </> : <div className="space-y-4" data-id="element-314">
              {selectedOption === 'yes' && <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-315">
                  <h3 className="text-lg font-semibold text-green-900 mb-3" data-id="element-316">
                    Great! You have a wholesale account
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-317">
                    <strong data-id="element-318">Important:</strong> Make sure you use the exact
                    email address associated with your wholesale account in the
                    quote builder to see wholesale pricing.
                  </p>
                </div>}

              {selectedOption === 'no' && <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-319">
                  <h3 className="text-lg font-semibold text-blue-900 mb-3" data-id="element-320">
                    How to Obtain a Wholesale Account
                  </h3>
                  <ol className="space-y-3 text-gray-700" data-id="element-321">
                    <li className="flex" data-id="element-322">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-323">1.</span>
                      <span data-id="element-324">
                        Email a copy of your business license or a legal
                        document with your Taekwondo School name to{' '}
                        <a href="mailto:shane@tkdscore.com" className="text-blue-600 hover:underline font-medium" data-id="element-325">
                          shane@tkdscore.com
                        </a>
                      </span>
                    </li>
                    <li className="flex" data-id="element-326">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-327">2.</span>
                      <span data-id="element-328">
                        Register at{' '}
                        <a href="https://www.tkdscore.com/register" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-medium" data-id="element-329">
                          www.tkdscore.com/register
                        </a>{' '}
                        and make sure you indicate what email address you
                        registered
                      </span>
                    </li>
                    <li className="flex" data-id="element-330">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-331">3.</span>
                      <span data-id="element-332">
                        We will respond after upgrading you to wholesale if
                        approved
                      </span>
                    </li>
                    <li className="flex" data-id="element-333">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-334">4.</span>
                      <span data-id="element-335">
                        Come back and build another quote to see wholesale
                        pricing
                      </span>
                    </li>
                  </ol>
                  <div className="mt-4 pt-4 border-t border-blue-200" data-id="element-336">
                    <p className="text-gray-700" data-id="element-337">
                      <strong data-id="element-338">Questions?</strong> Contact Shane Merem at{' '}
                      <a href="tel:+15172940315" className="text-blue-600 hover:underline font-medium" data-id="element-339">
                        (517) 294-0315
                      </a>{' '}
                      via Text
                    </p>
                  </div>
                </div>}

              {selectedOption === 'unsure' && <div className="bg-amber-50 border border-amber-200 rounded-lg p-4" data-id="element-340">
                  <h3 className="text-lg font-semibold text-amber-900 mb-3" data-id="element-341">
                    Not Sure if You Have a Wholesale Account?
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-3" data-id="element-342">
                    Try logging in to{' '}
                    <a href="https://www.tkdscore.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-medium" data-id="element-343">
                      www.tkdscore.com
                    </a>{' '}
                    and check if you have wholesale pricing available in your
                    account.
                  </p>
                  <p className="text-gray-700" data-id="element-344">
                    If you need assistance, contact Shane Merem at{' '}
                    <a href="tel:+15172940315" className="text-blue-600 hover:underline font-medium" data-id="element-345">
                      (517) 294-0315
                    </a>{' '}
                    via Text
                  </p>
                </div>}

              <button onClick={() => setSelectedOption(null)} className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-346">
                ← Back to options
              </button>
            </div>}
        </div>

        <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-347">
          <button onClick={handleClose} className="w-full bg-blue-600 text-white px-6 py-3 rounded-md font-bold hover:bg-blue-700 transition-colors" data-id="element-348">
            Close
          </button>
        </div>
      </div>
    </div>;
}